var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.016,
    height: 27.035,
    viewBox: "0 0 27.016 27.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-152.231 -151.982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.231,585.505a1.165,1.165,0,0,0,1.165,1.165h8.5v.254a1.165,1.165,0,0,0,.392.871,3.372,3.372,0,0,1,1.162,2.459c.008.366,0,.682,0,.952h4.593c-.009-.27-.012-.585,0-.952a3.372,3.372,0,0,1,1.162-2.459,1.165,1.165,0,0,0,.392-.871v-.254h8.5a1.165,1.165,0,0,0,1.165-1.165v-.968H152.231Z",
    transform: "translate(0 -415.754)",
    fill: "#159bc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.663,781.25H311.036a2.108,2.108,0,0,0-2.108,2.108h0a.485.485,0,0,0,.486.485h13.872a.485.485,0,0,0,.486-.485h0A2.108,2.108,0,0,0,321.663,781.25Z",
    transform: "translate(-150.611 -604.826)",
    fill: "#159bc4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.249,
    height: 2.592,
    transform: "translate(171.15 157.151)",
    fill: "#159bc4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.248,
    height: 2.592,
    transform: "translate(163.115 157.151)",
    fill: "#159bc4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.249,
    height: 2.592,
    transform: "translate(155.079 157.151)",
    fill: "#159bc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.082,151.982H153.4a1.165,1.165,0,0,0-1.165,1.165v14.665h27.016V153.147A1.165,1.165,0,0,0,178.082,151.982Zm-2.114,1.624h.917a.486.486,0,0,1,0,.971h-.917a.486.486,0,0,1,0-.971Zm-10.343,0h.916a.486.486,0,0,1,0,.971h-.916a.486.486,0,0,1,0-.971Zm-2.758,0h.916a.486.486,0,0,1,0,.971h-.916a.486.486,0,0,1,0-.971Zm-.723,3.04a.466.466,0,0,1,.466-.466h6.258a.466.466,0,0,1,.466.466v3.6a.466.466,0,0,1-.466.466H162.61a.466.466,0,0,1-.466-.466Zm-4.793-3.04h.917a.486.486,0,0,1,0,.971h-.917a.486.486,0,0,1,0-.971Zm-2.758,0h.917a.486.486,0,0,1,0,.971h-.917a.486.486,0,0,1,0-.971Zm6.705,12.1a.486.486,0,0,1-.486.486h-6.219a.486.486,0,0,1-.486-.486v-1.59a.486.486,0,0,1,.486-.486h6.219a.486.486,0,0,1,.486.486Zm-.486-3.047h-6.219a.486.486,0,0,1,0-.971h6.219a.486.486,0,1,1,0,.971Zm.486-2.408a.466.466,0,0,1-.466.466h-6.259a.466.466,0,0,1-.466-.466v-3.6a.466.466,0,0,1,.466-.466h6.259a.466.466,0,0,1,.466.466Zm-.273-5.671h-.917a.486.486,0,0,1,0-.971h.917a.486.486,0,0,1,0,.971Zm8.309,11.126a.485.485,0,0,1-.486.486h-6.219a.486.486,0,0,1-.486-.486v-1.59a.486.486,0,0,1,.486-.486h6.219a.486.486,0,0,1,.486.486Zm-.486-3.047h-6.219a.486.486,0,0,1,0-.971h6.219a.486.486,0,0,1,0,.971Zm8.521,3.047a.486.486,0,0,1-.486.486h-6.219a.486.486,0,0,1-.486-.486v-1.59a.486.486,0,0,1,.486-.486h6.22a.486.486,0,0,1,.486.486v1.59Zm-.486-3.047h-6.219a.486.486,0,0,1,0-.971h6.22a.486.486,0,1,1,0,.971Zm.486-2.408a.466.466,0,0,1-.466.466h-6.259a.466.466,0,0,1-.466-.466v-3.6a.466.466,0,0,1,.466-.466H176.9a.466.466,0,0,1,.466.466Z",
    fill: "#159bc4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontendIcon);
export default __webpack_public_path__ + "static/media/frontend-icon.7e9d081e566e6555c484623f8343ccea.svg";
export { ForwardRef as ReactComponent };